<template>
  <v-autocomplete
    @change="change"
    :items="items"
    :placeholder="placeholder"
    loading="isLoading"
    no-data-text="No data"
    append-icon="search"
    solo
  />
</template>

<script>
export default {
  name: 'AppAutoCompleteSearch',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    change(value) {
      this.$emit('change', value)
    },
  },
}
</script>

<style scoped></style>
